import { render, staticRenderFns } from "./AreaSocios.vue?vue&type=template&id=9190851e&"
import script from "./AreaSocios.vue?vue&type=script&lang=js&"
export * from "./AreaSocios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports